import { ReactNode } from 'react';

type CardProps = {
  children: ReactNode;
  className?: string;
};

export const Card = ({ children, className = '' }: CardProps) => {
  return (
    <div
      className={`bg-white rounded-bonusLarge p-4 shadow-lg ${className} print:hidden`}
    >
      {children}
    </div>
  );
};
